import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const DocumentArchive = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill="none"
      {...rest}
    >
      <path
        d="M21.2988 7.08154V17.0815C21.2988 20.0815 19.7988 22.0815 16.2988 22.0815H8.29883C4.79883 22.0815 3.29883 20.0815 3.29883 17.0815V7.08154C3.29883 4.08154 4.79883 2.08154 8.29883 2.08154H16.2988C19.7988 2.08154 21.2988 4.08154 21.2988 7.08154Z"
        stroke="#32323C"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.7988 2.08154V9.94153C15.7988 10.3815 15.2788 10.6015 14.9588 10.3115L12.6389 8.17157C12.4489 7.99157 12.1488 7.99157 11.9588 8.17157L9.63885 10.3115C9.31885 10.6015 8.79883 10.3815 8.79883 9.94153V2.08154H15.7988Z"
        stroke="#32323C"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M13.5488 14.0815H17.7988"
        stroke="#32323C"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.29883 18.0815H17.7988"
        stroke="#32323C"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DocumentArchive.displayName = 'DocumentArchive';
